<template>
  <!-- faq -->
  <div class="faq-section faq-banner-bg">
    <img src="@/assets/img/bg/bg-21.svg" alt="img" class="d-lg-flex d-none faq-bg2" />
    <img src="@/assets/img/bg/bg-22.svg" alt="img" class="d-lg-flex d-none faq-bg3" />
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="faq-img" data-aos="fade-up">
            <img
              class="img-fluid rounded-5"
              src="@/assets/img/feature/feature-4.jpg"
              alt="img"
            />
            <span><i class="isax isax-message-question5"></i></span>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="faq-content">
            <div class="section-header" data-aos="fade-up">
              <span
                class="fw-medium text-secondary text-decoration-underline mb-2 d-inline-block"
                >Your Questions are Answered</span
              >
              <h2 class="mb-1">Frequently Asked Questions</h2>
              <p>
                Explore detailed answers to the most common questions about our platform.
              </p>
            </div>
            <div
              class="accordion accordion-customicon1 accordions-items-seperate"
              id="accordioncustomicon1Example"
            >
              <div class="accordion-item" data-aos="fade-up">
                <h2 class="accordion-header" id="headingcustomicon1One">
                  <a
                    href="#"
                    class="accordion-button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsecustomicon1One"
                    aria-expanded="true"
                    aria-controls="collapsecustomicon1One"
                  >
                    How do I enroll in a course?
                    <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                  </a>
                </h2>
                <div
                  id="collapsecustomicon1One"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingcustomicon1One"
                  data-bs-parent="#accordioncustomicon1Example"
                >
                  <div class="accordion-body pt-0">
                    <p>
                      Many websites offer a Certificate of Completion for paid courses.
                      Free courses may or may not include a certificate, depending on the
                      platform’s policies.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
                <h2 class="accordion-header" id="headingcustomicon1Two">
                  <a
                    href="#"
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsecustomicon1Two"
                    aria-expanded="false"
                    aria-controls="collapsecustomicon1One"
                  >
                    How long do I have access to a course?
                    <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                  </a>
                </h2>
                <div
                  id="collapsecustomicon1Two"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingcustomicon1Two"
                  data-bs-parent="#accordioncustomicon1Example"
                >
                  <div class="accordion-body pt-0">
                    <p>
                      Many websites offer a Certificate of Completion for paid courses.
                      Free courses may or may not include a certificate, depending on the
                      platform’s policies.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
                <h2 class="accordion-header" id="headingcustomicon1Three">
                  <a
                    href="#"
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsecustomicon1Three"
                    aria-expanded="false"
                    aria-controls="collapsecustomicon1One"
                  >
                    What payment methods are accepted?
                    <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                  </a>
                </h2>
                <div
                  id="collapsecustomicon1Three"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingcustomicon1Three"
                  data-bs-parent="#accordioncustomicon1Example"
                >
                  <div class="accordion-body pt-0">
                    <p>
                      Many websites offer a Certificate of Completion for paid courses.
                      Free courses may or may not include a certificate, depending on the
                      platform’s policies.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
                <h2 class="accordion-header" id="headingcustomicon1Four">
                  <a
                    href="#"
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsecustomicon1Four"
                    aria-expanded="false"
                    aria-controls="collapsecustomicon1One"
                  >
                    Will I receive a certificate after completing a course?
                    <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                  </a>
                </h2>
                <div
                  id="collapsecustomicon1Four"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingcustomicon1Four"
                  data-bs-parent="#accordioncustomicon1Example"
                >
                  <div class="accordion-body pt-0">
                    <p>
                      Many websites offer a Certificate of Completion for paid courses.
                      Free courses may or may not include a certificate, depending on the
                      platform’s policies.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
                <h2 class="accordion-header" id="headingcustomicon1Five">
                  <a
                    href="#"
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsecustomicon1Five"
                    aria-expanded="false"
                    aria-controls="collapsecustomicon1One"
                  >
                    What is the purpose of this NextSense ?
                    <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                  </a>
                </h2>
                <div
                  id="collapsecustomicon1Five"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingcustomicon1Five"
                  data-bs-parent="#accordioncustomicon1Example"
                >
                  <div class="accordion-body pt-0">
                    <p>
                      Many websites offer a Certificate of Completion for paid courses.
                      Free courses may or may not include a certificate, depending on the
                      platform’s policies.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-delay="250">
                <h2 class="accordion-header" id="headingcustomicon1Six">
                  <a
                    href="#"
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapsecustomicon1Six"
                    aria-expanded="false"
                    aria-controls="collapsecustomicon1One"
                  >
                    What can I do with my certificate?
                    <i class="isax isax-add fs-20 fw-semibold ms-1"></i>
                  </a>
                </h2>
                <div
                  id="collapsecustomicon1Six"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingcustomicon1Six"
                  data-bs-parent="#accordioncustomicon1Example"
                >
                  <div class="accordion-body pt-0">
                    <p>
                      Many websites offer a Certificate of Completion for paid courses.
                      Free courses may or may not include a certificate, depending on the
                      platform’s policies.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- faq -->

  <!-- Latest Blog -->
  <section class="latest-blog-three latest-blog-five">
    <div class="container">
      <div class="section-header text-center" data-aos="fade-up">
        <span
          class="fw-medium text-secondary text-decoration-underline mb-2 d-inline-block"
          >Articles & Updates</span
        >
        <h2>Our Recent Blog & Articles</h2>
        <p>Explore curated content to enlighten, entertain and engage global readers.</p>
      </div>
      <div class="latest-blog-main">
        <div class="row">
          <div class="col-lg-4">
            <div class="event-blog-three blog-three-one" data-aos="fade-up">
              <div class="blog-img-three">
                <router-link to="/blog-layouts/blog-grid">
                  <img class="img-fluid" alt="Img" src="@/assets/img/blog/blog-35.jpg" />
                </router-link>
              </div>
              <div class="latest-blog-content">
                <div class="event-three-title">
                  <div class="event-span-three d-flex align-items-center">
                    <span class="category">Lifestyle</span>
                    <div class="blog-date">
                      <i class="fa-solid fa-calendar"></i><span>09 Aug 2025</span>
                    </div>
                  </div>
                  <router-link to="/blog-layouts/blog-grid">
                    <h5>Why an LMS is Essential for Modern Education</h5>
                  </router-link>
                </div>
              </div>
              <div class="blog-user-top">
                <a href="#"
                  ><img src="@/assets/img/user/user-01.jpg" alt="" />David Benitez</a
                >
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="row">
              <div class="col-md-6">
                <div class="event-blog-three blog-three-one" data-aos="fade-up">
                  <div class="blog-img-three">
                    <router-link to="/blogs/blog-details">
                      <img
                        class="img-fluid"
                        alt="Img"
                        src="@/assets/img/blog/blog-36.jpg"
                      />
                    </router-link>
                  </div>
                  <div class="latest-blog-content">
                    <div class="event-three-title">
                      <div class="event-span-three d-flex align-items-center">
                        <span class="category">Productivity</span>
                        <div class="blog-date">
                          <i class="fa-solid fa-calendar"></i> <span>09 Aug 2025</span>
                        </div>
                      </div>
                      <h5>
                        <router-link to="/blog-layouts/blog-grid"
                          >The Impact of LMS on Academic Journey Education</router-link
                        >
                      </h5>
                    </div>
                  </div>
                  <div class="blog-user-top">
                    <a href="#"
                      ><img src="@/assets/img/user/user-01.jpg" alt="" />David Benitez</a
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="event-blog-three blog-three-one" data-aos="fade-up">
                  <div class="blog-img-three">
                    <router-link to="/blog-layouts/blog-grid">
                      <img
                        class="img-fluid"
                        alt="Img"
                        src="@/assets/img/blog/blog-38.jpg"
                      />
                    </router-link>
                  </div>
                  <div class="latest-blog-content">
                    <div class="event-three-title">
                      <div class="event-span-three d-flex align-items-center">
                        <span class="category">Productivity</span>
                        <div class="blog-date">
                          <i class="fa-solid fa-calendar"></i><span>09 Aug 2025</span>
                        </div>
                      </div>
                      <h5>
                        <router-link to="/blog-layouts/blog-grid"
                          >Maximizing Academic Success with the Right LMS</router-link
                        >
                      </h5>
                    </div>
                  </div>
                  <div class="blog-user-top">
                    <a href="#"
                      ><img src="@/assets/img/user/user-01.jpg" alt="" />David Benitez</a
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="event-blog-three blog-three-one" data-aos="fade-up">
                  <div class="blog-img-three">
                    <router-link to="/blog-layouts/blog-grid">
                      <img
                        class="img-fluid"
                        alt="Img"
                        src="@/assets/img/blog/blog-37.jpg"
                      />
                    </router-link>
                  </div>
                  <div class="latest-blog-content">
                    <div class="event-three-title">
                      <div class="event-span-three d-flex align-items-center">
                        <span class="category">UI /UX</span>
                        <div class="blog-date">
                          <i class="fa-solid fa-calendar"></i><span>09 Aug 2025</span>
                        </div>
                      </div>
                      <h5>
                        <router-link to="/blog-layouts/blog-grid"
                          >Promoting Health & Well being in Schools</router-link
                        >
                      </h5>
                    </div>
                  </div>
                  <div class="blog-user-top">
                    <a href="#"
                      ><img src="@/assets/img/user/user-01.jpg" alt="" />David Benitez</a
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="event-blog-three blog-three-one" data-aos="fade-up">
                  <div class="blog-img-three">
                    <router-link to="/blog-layouts/blog-grid">
                      <img
                        class="img-fluid"
                        alt="Img"
                        src="@/assets/img/blog/blog-39.jpg"
                      />
                    </router-link>
                  </div>
                  <div class="latest-blog-content">
                    <div class="event-three-title">
                      <div class="event-span-three d-flex align-items-center">
                        <span class="category">Development</span>
                        <div class="blog-date">
                          <i class="fa-solid fa-calendar"></i><span>09 Aug 2025</span>
                        </div>
                      </div>
                      <h5>
                        <router-link to="/blog-layouts/blog-grid"
                          >How to Build and Run a Pilot Mentoring Program</router-link
                        >
                      </h5>
                    </div>
                  </div>
                  <div class="blog-user-top">
                    <a href="#"
                      ><img src="@/assets/img/user/user-01.jpg" alt="" />David Benitez</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <router-link
          class="btn btn-view-all"
          data-aos="fade-up"
          to="/blog-layouts/blog-grid"
          >View All Articles</router-link
        >
      </div>
    </div>
  </section>
  <!-- /Latest Blog -->
</template>
